// ToastContext.tsx
import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { Snackbar, Slide } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { useSelector } from 'react-redux';

const AlluserContext = createContext(undefined);

export const AllUserProvider = ({ children }) => {
  const [allUsers, setAllUsers] = useState([]);
  const { authUser } = useSelector(({ auth }) => auth);

  useEffect(() => {
    getAllUsers();
  }, [authUser]);

  const getAllUsers = () => {
    if (!authUser) return;
    customAxios
      .get('/User/GetAllUsers', { headers: authHeader() })
      .then(data => {
        if (data.status == 200) {
          setAllUsers(data.data);
        } else {
          setAllUsers([]);
        }
      })
      .catch(() => {
        setAllUsers([]);
      });
  };

  return <AlluserContext.Provider value={{ getAllUsers, allUsers }}>{children}</AlluserContext.Provider>;
};

export const useAllUsers = () => {
  const context = useContext(AlluserContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};
